module.exports = __webpack_public_path__ + "img/download_grey.8c513c58.svg";